import type { Session } from '@supabase/supabase-js'

import { recordFailure } from '@/assets/composables/diagnostics'

export type AuthStage =
  | 'session'
  | 'activation'
  | 'refresh'
  | 'settings'
  | 'store'
  | 'oauth'
  | 'password'
  | 'callback'

const endpoints: Partial<Record<AuthStage, string>> = {
  activation: '/api/v1/account/activate',
  refresh: '/auth/v1/token',
  callback: '/auth/v1/token',
  settings: '/api/v1/parking/settings',
}

export const authFailureContext = (session: Session | null) => ({
  hasValidSession:
    !!session?.user && !!session.access_token && (session.expires_at ?? 0) > Date.now() / 1000,
})

// Authentication adds only its own safe context to the common error reporter.
export const recordAuthFailure = (
  stage: AuthStage,
  error: unknown,
  session: Session | null = null,
  elapsedMs = 0,
) =>
  recordFailure(error, {
    area: 'auth',
    operation: stage,
    endpoint: endpoints[stage],
    elapsedMs,
    policy: authFailureContext(session),
    identity: {
      userId: session?.user?.id ?? null,
      signedIn: !!session,
      accessPresent: !!session?.access_token,
      rolePresent: !!session?.user?.app_metadata?.roles?.includes('pelikanec-user'),
      expiresAt:
        session?.expires_at &&
        Number.isFinite(session.expires_at) &&
        Math.abs(session.expires_at) < 8.64e12
          ? new Date(session.expires_at * 1000).toISOString()
          : null,
    },
  })
